import { render, staticRenderFns } from "./VentaCotizacionGeneral.vue?vue&type=template&id=4bd97175&"
import script from "./VentaCotizacionGeneral.vue?vue&type=script&lang=js&"
export * from "./VentaCotizacionGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports